import { Image } from '@cian/ui-kit/image';

import { FC } from 'react';

import { useCoworkingOperatorCompanyNameSelector } from 'shared/hooks/selectors/coworking/useCoworkingOperatorCompanyNameSelector';
import { useCoworkingOperatorLogoSelector } from 'shared/hooks/selectors/coworking/useCoworkingOperatorLogoSelector';

import { CoworkingActionsButtons } from './CoworkingActionsButtons';
import { OperatorInfo } from './OperatorInfo';
import { PlacementApplication } from './PlacementApplication';

import * as styles from './InfoCardBody.css';

export const InfoCardBody: FC = () => {
  const coworkingOperatorCompanyName = useCoworkingOperatorCompanyNameSelector();
  const coworkingOperatorLogo = useCoworkingOperatorLogoSelector();

  return (
    <div className={styles['container']}>
      {coworkingOperatorCompanyName && (
        <div className={styles['about-coworking-container']}>
          <OperatorInfo name={coworkingOperatorCompanyName} type="Оператор коворкингов" />
          <div className={styles['logo-container']}>
            <Image height={48} src={coworkingOperatorLogo} width={48} />
          </div>
        </div>
      )}
      <CoworkingActionsButtons />
      <PlacementApplication />
    </div>
  );
};

InfoCardBody.displayName = 'InfoCardBody';
